import React, { useState } from "react";
import toast from "react-hot-toast";

const SERVICES = [
  { group: "🧹 PureProCleaners", items: ["Nettoyage & Entretien", "Entretien de Piscine", "Maintenance Climatisation", "Traitement Nuisibles 3D"] },
  { group: "💻 PureProTechnologie", items: ["Application Mobile", "Site Web / E-commerce", "Cybersécurité", "Équipement IT", "Formation & IA", "Cloud & Infrastructure"] },
];

const BUDGETS = [
  "Moins de 100 000 FCFA",
  "100 000 – 500 000 FCFA",
  "500 000 – 1 000 000 FCFA",
  "1 000 000 – 5 000 000 FCFA",
  "Plus de 5 000 000 FCFA",
  "À définir ensemble",
];

const DELAIS = [
  "Urgent (moins d'une semaine)",
  "1 à 2 semaines",
  "1 mois",
  "2 à 3 mois",
  "Plus de 3 mois",
  "Flexible",
];

const STEPS = ["Vos coordonnées", "Votre projet", "Confirmation"];

export default function Devis() {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    name: "", company: "", email: "", phone: "",
    service: "", budget: "", delai: "", description: "", fichier: "",
  });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const next = () => {
    if (step === 0 && (!form.name || !form.email || !form.phone)) {
      toast.error("Veuillez remplir votre nom, email et téléphone.");
      return;
    }
    if (step === 1 && (!form.service || !form.description)) {
      toast.error("Veuillez sélectionner un service et décrire votre projet.");
      return;
    }
    setStep(s => s + 1);
  };

  const submit = async () => {
    setSending(true);
    try {
      const res = await fetch("https://back-purepro.onrender.com/demande-devis", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          company: form.company,
          email: form.email,
          phone: form.phone,
          service: form.service,
          budget: form.budget,
          delai: form.delai,
          description: form.description,
          source: "pureprogroup",
        }),
      });
      if (!res.ok) throw new Error();
      setSent(true);
      toast.success("Demande envoyée ! Vous serez contacté sous 24h.");
    } catch {
      toast.error("Erreur lors de l'envoi. Appelez-nous directement.");
    } finally {
      setSending(false);
    }
  };

  if (sent) {
    return (
      <div style={{ paddingTop: "72px", minHeight: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center", maxWidth: "520px", padding: "0 24px" }}>
          <div style={{ fontSize: "64px", marginBottom: "20px" }}>🎉</div>
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "30px", color: "#0a2540", marginBottom: "12px" }}>
            Demande envoyée avec succès !
          </h2>
          <p style={{ color: "#4a5a6a", fontSize: "15px", lineHeight: 1.8, marginBottom: "8px" }}>
            Merci <strong>{form.name}</strong> pour votre confiance.
          </p>
          <p style={{ color: "#4a5a6a", fontSize: "15px", lineHeight: 1.8, marginBottom: "32px" }}>
            Notre équipe analysera votre demande et vous contactera sous <strong>24h ouvrables</strong>
            à l'adresse <strong>{form.email}</strong> pour un devis détaillé et gratuit.
          </p>
          <div style={s.confirmBox}>
            <div style={s.confirmRow}><span style={s.confirmLabel}>Service :</span><span>{form.service}</span></div>
            {form.budget && <div style={s.confirmRow}><span style={s.confirmLabel}>Budget :</span><span>{form.budget}</span></div>}
            {form.delai && <div style={s.confirmRow}><span style={s.confirmLabel}>Délai :</span><span>{form.delai}</span></div>}
          </div>
          <button className="btn btn-primary" onClick={() => { setSent(false); setStep(0); setForm({ name: "", company: "", email: "", phone: "", service: "", budget: "", delai: "", description: "" }); }}>
            Nouvelle demande
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: "72px" }}>
      {/* Styles responsives */}
      <style>{`
        /* Base */
        .container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .section {
          padding: 80px 0;
        }
        .section-tag {
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #c9a227;
          display: inline-block;
        }
        .btn-primary, .btn-outline-navy, .btn-navy {
          display: inline-block;
          border-radius: 40px;
          font-weight: 700;
          text-decoration: none;
          transition: all 0.2s;
          cursor: pointer;
          text-align: center;
          padding: 10px 22px;
          font-size: 13px;
          border: none;
        }
        .btn-primary {
          background: #c9a227;
          color: #0a2540;
        }
        .btn-primary:hover {
          background: #b38c1a;
          transform: translateY(-2px);
        }
        .btn-outline-navy {
          background: transparent;
          border: 1.5px solid #0a2540;
          color: #0a2540;
        }
        .btn-outline-navy:hover {
          background: #0a2540;
          color: white;
        }
        .btn-navy {
          background: #0a2540;
          color: white;
        }
        .btn-navy:hover {
          background: #1e3a5f;
        }

        /* Grille principale */
        .devis-wrapper {
          display: grid;
          grid-template-columns: 1fr 340px;
          gap: 40px;
          align-items: start;
        }

        /* Stepper responsive */
        .devis-stepper {
          display: flex;
          gap: 0;
          margin-bottom: 28px;
          grid-column: 1 / -1;
          align-items: center;
          flex-wrap: wrap;
        }
        .step-item {
          display: flex;
          align-items: center;
          gap: 10px;
          flex: 1;
          position: relative;
        }
        .step-dot {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #eef1f8;
          border: 2px solid #d8e0e8;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          font-weight: 700;
          color: #8a9aaa;
          flex-shrink: 0;
          z-index: 1;
        }
        .step-dot.active {
          background: #c9a227;
          border-color: #c9a227;
          color: #fff;
        }
        .step-label {
          font-size: 13px;
          color: #8a9aaa;
          white-space: nowrap;
        }
        .step-label.active {
          color: #0a2540;
          font-weight: 700;
        }
        .step-line {
          flex: 1;
          height: 2px;
          background: #d8e0e8;
          margin: 0 12px;
          transition: background .3s;
        }
        .step-line.active {
          background: #c9a227;
        }

        /* Formulaire */
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }
        .form-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 8px;
          gap: 12px;
        }

        /* Aside (garanties) */
        .devis-aside {
          background: #fff;
          border: 1px solid #d8e0e8;
          border-radius: 20px;
          padding: 28px;
          box-shadow: 0 4px 20px rgba(10,37,64,.06);
          display: flex;
          flex-direction: column;
          gap: 20px;
          position: sticky;
          top: 90px;
        }

        /* Media queries */
        @media (max-width: 992px) {
          .section { padding: 60px 0; }
          .devis-wrapper { gap: 30px; }
        }
        @media (max-width: 768px) {
          .container { padding: 0 20px; }
          .devis-wrapper { grid-template-columns: 1fr; }
          .devis-stepper { flex-direction: column; align-items: flex-start; gap: 12px; }
          .step-item { width: 100%; }
          .step-line { display: none; }
          .step-label { white-space: normal; }
          .form-row { grid-template-columns: 1fr; }
          .form-actions { flex-direction: column-reverse; }
          .form-actions button { width: 100%; }
          .devis-aside { position: static; margin-top: 20px; }
          .hero-title { font-size: 32px !important; }
          .hero-sub { font-size: 15px !important; }
        }
        @media (max-width: 480px) {
          .section-title { font-size: 28px; }
          .form-card { padding: 20px !important; }
          .recap { padding: 16px !important; }
        }
      `}</style>

      {/* ─── Hero ─── */}
      <section style={s.hero}>
        <div style={s.heroBg} />
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <span className="section-tag">Gratuit & sans engagement</span>
          <h1 style={s.heroTitle}>Demandez votre <span style={{ color: "#c9a227" }}>devis</span></h1>
          <p style={s.heroSub}>
            Remplissez le formulaire en 3 étapes. Nous vous envoyons un devis personnalisé sous 24h, gratuitement.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="devis-wrapper">

            {/* Stepper */}
            <div className="devis-stepper">
              {STEPS.map((label, i) => (
                <div key={label} className="step-item">
                  <div className={`step-dot ${i <= step ? 'active' : ''}`}>{i + 1}</div>
                  <div className={`step-label ${i <= step ? 'active' : ''}`}>{label}</div>
                  {i < STEPS.length - 1 && <div className={`step-line ${i < step ? 'active' : ''}`} />}
                </div>
              ))}
            </div>

            {/* Formulaire */}
            <div style={s.formCard}>

              {/* Étape 0 — Coordonnées */}
              {step === 0 && (
                <div style={s.stepContent}>
                  <h2 style={s.stepTitle}>Vos coordonnées</h2>
                  <p style={s.stepSub}>Ces informations nous permettront de vous recontacter avec votre devis.</p>
                  <div className="form-row">
                    <div style={s.field}>
                      <label style={s.label}>Nom complet *</label>
                      <input style={s.input} placeholder="Jean Kouamé" value={form.name} onChange={set("name")} />
                    </div>
                    <div style={s.field}>
                      <label style={s.label}>Entreprise (optionnel)</label>
                      <input style={s.input} placeholder="Nom de votre société" value={form.company} onChange={set("company")} />
                    </div>
                  </div>
                  <div className="form-row">
                    <div style={s.field}>
                      <label style={s.label}>Email *</label>
                      <input style={s.input} type="email" placeholder="jean@exemple.com" value={form.email} onChange={set("email")} />
                    </div>
                    <div style={s.field}>
                      <label style={s.label}>Téléphone *</label>
                      <input style={s.input} placeholder="+225 07 00 00 00 00" value={form.phone} onChange={set("phone")} />
                    </div>
                  </div>
                  <div className="form-actions">
                    <button className="btn btn-primary" onClick={next} style={{ marginLeft: "auto" }}>
                      Étape suivante →
                    </button>
                  </div>
                </div>
              )}

              {/* Étape 1 — Projet */}
              {step === 1 && (
                <div style={s.stepContent}>
                  <h2 style={s.stepTitle}>Votre projet</h2>
                  <p style={s.stepSub}>Décrivez votre besoin. Plus vous êtes précis, plus le devis sera adapté.</p>

                  <div style={s.field}>
                    <label style={s.label}>Service concerné *</label>
                    <select style={s.input} value={form.service} onChange={set("service")}>
                      <option value="">-- Sélectionner un service --</option>
                      {SERVICES.map(({ group, items }) => (
                        <optgroup key={group} label={group}>
                          {items.map(it => <option key={it} value={it}>{it}</option>)}
                        </optgroup>
                      ))}
                    </select>
                  </div>

                  <div className="form-row">
                    <div style={s.field}>
                      <label style={s.label}>Budget estimé</label>
                      <select style={s.input} value={form.budget} onChange={set("budget")}>
                        <option value="">-- Sélectionner --</option>
                        {BUDGETS.map(b => <option key={b} value={b}>{b}</option>)}
                      </select>
                    </div>
                    <div style={s.field}>
                      <label style={s.label}>Délai souhaité</label>
                      <select style={s.input} value={form.delai} onChange={set("delai")}>
                        <option value="">-- Sélectionner --</option>
                        {DELAIS.map(d => <option key={d} value={d}>{d}</option>)}
                      </select>
                    </div>
                  </div>

                  <div style={s.field}>
                    <label style={s.label}>Description du projet *</label>
                    <textarea
                      style={{ ...s.input, minHeight: "150px", resize: "vertical" }}
                      placeholder="Décrivez votre projet, vos besoins, vos attentes, la superficie à traiter (pour nettoyage), les fonctionnalités souhaitées (pour tech)..."
                      value={form.description}
                      onChange={set("description")}
                    />
                  </div>

                  <div className="form-actions">
                    <button className="btn btn-outline-navy" onClick={() => setStep(0)}>← Précédent</button>
                    <button className="btn btn-primary" onClick={next}>Vérifier & confirmer →</button>
                  </div>
                </div>
              )}

              {/* Étape 2 — Confirmation */}
              {step === 2 && (
                <div style={s.stepContent}>
                  <h2 style={s.stepTitle}>Confirmation</h2>
                  <p style={s.stepSub}>Vérifiez vos informations avant d'envoyer votre demande.</p>

                  <div style={s.recap}>
                    <div style={s.recapSection}>
                      <div style={s.recapTitle}>📋 Vos coordonnées</div>
                      <div style={s.confirmRow}><span style={s.confirmLabel}>Nom</span><span>{form.name}</span></div>
                      {form.company && <div style={s.confirmRow}><span style={s.confirmLabel}>Entreprise</span><span>{form.company}</span></div>}
                      <div style={s.confirmRow}><span style={s.confirmLabel}>Email</span><span>{form.email}</span></div>
                      <div style={s.confirmRow}><span style={s.confirmLabel}>Téléphone</span><span>{form.phone}</span></div>
                    </div>
                    <div style={s.recapSection}>
                      <div style={s.recapTitle}>🎯 Votre projet</div>
                      <div style={s.confirmRow}><span style={s.confirmLabel}>Service</span><span style={{ fontWeight: 700, color: "#c9a227" }}>{form.service}</span></div>
                      {form.budget && <div style={s.confirmRow}><span style={s.confirmLabel}>Budget</span><span>{form.budget}</span></div>}
                      {form.delai && <div style={s.confirmRow}><span style={s.confirmLabel}>Délai</span><span>{form.delai}</span></div>}
                      <div style={{ marginTop: "10px" }}>
                        <div style={s.confirmLabel}>Description</div>
                        <div style={{ fontSize: "13px", color: "#4a5a6a", lineHeight: 1.7, marginTop: "6px", background: "#f8f9fc", padding: "12px", borderRadius: "8px" }}>{form.description}</div>
                      </div>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button className="btn btn-outline-navy" onClick={() => setStep(1)}>← Modifier</button>
                    <button className="btn btn-primary" onClick={submit} disabled={sending} style={{ opacity: sending ? .7 : 1, fontSize: "15px", padding: "14px 28px" }}>
                      {sending ? "Envoi en cours..." : "✓ Envoyer ma demande"}
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Aside garanties */}
            <div className="devis-aside">
              <div style={s.asideTitle}>✅ Nos garanties</div>
              {[
                { icon: "⚡", t: "Réponse sous 24h", d: "Votre devis personnalisé vous sera envoyé sous 24h ouvrables." },
                { icon: "🆓", t: "100% Gratuit", d: "La demande de devis et le devis lui-même sont entièrement gratuits." },
                { icon: "🔒", t: "Sans engagement", d: "Vous n'êtes engagé à rien. Vous décidez ensuite librement." },
                { icon: "🤝", t: "Suivi dédié", d: "Un consultant vous accompagne de la demande à la livraison." },
              ].map(({ icon, t, d }) => (
                <div key={t} style={s.guarantee}>
                  <div style={s.gIcon}>{icon}</div>
                  <div>
                    <div style={s.gTitle}>{t}</div>
                    <div style={s.gDesc}>{d}</div>
                  </div>
                </div>
              ))}
              <div style={s.callBox}>
                <div style={{ fontSize: "13px", fontWeight: 700, color: "#0a2540", marginBottom: "8px" }}>Préférez appeler ?</div>
                <a href="tel:+2250575496457" className="btn btn-navy" style={{ justifyContent: "center", width: "100%", fontSize: "13px" }}>
                  📞 +225 05 75 49 64 57
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

const s = {
  hero: { background: "linear-gradient(135deg, #0a2540 0%, #1e3a5f 100%)", padding: "70px 0", position: "relative", overflow: "hidden" },
  heroBg: { position: "absolute", inset: 0, background: "radial-gradient(ellipse at 80% 50%, rgba(201,162,39,.08), transparent 60%)" },
  heroTitle: { fontFamily: "'Playfair Display',serif", fontSize: "clamp(32px,5vw,50px)", fontWeight: 700, color: "#fff", lineHeight: 1.2, margin: "14px 0 18px" },
  heroSub: { fontSize: "16px", color: "rgba(255,255,255,.7)", maxWidth: "520px", lineHeight: 1.8 },
  formCard: { background: "#fff", border: "1px solid #d8e0e8", borderRadius: "20px", padding: "36px", boxShadow: "0 8px 40px rgba(10,37,64,.1)" },
  stepContent: { display: "flex", flexDirection: "column", gap: "20px" },
  stepTitle: { fontFamily: "'Playfair Display',serif", fontSize: "22px", fontWeight: 700, color: "#0a2540" },
  stepSub: { fontSize: "13px", color: "#8a9aaa", marginTop: "-12px" },
  field: { display: "flex", flexDirection: "column", gap: "6px" },
  label: { fontSize: "12px", fontWeight: 700, color: "#0a2540", letterSpacing: ".3px" },
  input: { padding: "11px 14px", border: "1.5px solid #d8e0e8", borderRadius: "8px", fontSize: "14px", color: "#1a2a3a", outline: "none", fontFamily: "inherit", width: "100%", background: "#fafbfc" },
  recap: { display: "flex", flexDirection: "column", gap: "20px", background: "#f8f9fc", borderRadius: "12px", padding: "24px" },
  recapSection: { display: "flex", flexDirection: "column", gap: "8px" },
  recapTitle: { fontSize: "13px", fontWeight: 700, color: "#0a2540", marginBottom: "4px" },
  confirmBox: { background: "#f8f9fc", border: "1px solid #d8e0e8", borderRadius: "12px", padding: "16px 20px", display: "flex", flexDirection: "column", gap: "8px", marginTop: "20px" },
  confirmRow: { display: "flex", justifyContent: "space-between", fontSize: "13px", color: "#4a5a6a", gap: "12px" },
  confirmLabel: { fontWeight: 700, color: "#0a2540", flexShrink: 0 },
  asideTitle: { fontSize: "14px", fontWeight: 700, color: "#0a2540" },
  guarantee: { display: "flex", gap: "12px", alignItems: "flex-start" },
  gIcon: { fontSize: "20px", flexShrink: 0, marginTop: "2px" },
  gTitle: { fontSize: "13px", fontWeight: 700, color: "#0a2540", marginBottom: "3px" },
  gDesc: { fontSize: "12px", color: "#8a9aaa", lineHeight: 1.6 },
  callBox: { borderTop: "1px solid #eef1f8", paddingTop: "16px", marginTop: "4px" },
};